export default String.raw`
{% assign product = product-presentation.Product -%}
{% assign url = page.Url -%}

{% comment -%}<!-- Product -->{% endcomment -%}
{% if page.QueryString contains 'set-product-id' -%}
    {% assign queries = page.QueryString | Split:'&' -%}
    {% for query in queries -%}
        {% if query contains 'set-product-id' -%}
            {% assign queryString = query | Split:'=' -%}
            {% assign setProductId = queryString[1] -%}
        {% endif -%}
    {% endfor -%}
    {% for set in product.Sets -%}
        {% for sp in set.Products -%}
            {% if sp.Id == setProductId -%}
                {% assign setProduct = sp -%}
            {% endif -%}
        {% endfor -%}
    {% endfor -%}
{% else -%}
    {% assign setProduct = include -%}
    {% assign setProductId = setProduct.Id -%}
{% endif -%}

{% comment -%}<!-- Keys -->{% endcomment -%}
{% if page.QueryString contains 'set-product-keys' -%}
    {% assign queries = page.QueryString | Split:'&' -%}
    {% for query in queries -%}
        {% if query contains 'set-product-keys' -%}
            {% assign queryString = query | Split:'=' -%}
            {% assign joinedKeys = queryString[1] | Replace: '%2c', ',' -%}
            {% assign keys = joinedKeys | Split:',' -%}
        {% endif -%}
    {% endfor -%}
{% else -%}
    {% assign joinedKeys = setProduct.Supplies.Key | Replace: '%2c', ',' -%}
    {% assign keys = joinedKeys | Split:',' -%}
{% endif -%}

{% assign supplies = setProduct.Supplies.Supplies -%}
{% for atName in setProduct.Supplies.AttributeNames -%}
    {% assign lvl = forloop.index -%}
    <div class="form__input-wrapper">
        <label for="atName{{ forloop.index }}" class="form__input-info input-info-js on-label">{{ atName.Name }}</label>
        {% assign key = keys[forloop.index0] -%}
        <div tabindex="0" class="form__input-value select select-js">
            <select id="atName{{ forloop.index }}" class="memory-js replace-template-js" name="attribute">
                {% for supply in supplies -%}
                    {% if supply.Key -%}
                        {% assign dataKeys = supply.Key -%}
                    {% else -%}
                        {% assign childs = supply.Supplies -%}
                        {% assign size = keys | Size -%}
                        {% assign end = size | Minus: lvl -%}
                        {% for lvl in (1..end) -%}
                        {% for child in childs -%}
                            {% if child.ValueId == childs[0].ValueId -%}
                                {% unless child.Key -%}
                                    {% assign childs = child.Supplies -%}
                                {% else -%}
                                    {% assign dataKeys = child.Key -%}
                                {% endunless -%}
                                {% break -%}
                            {% endif -%}
                        {% endfor -%}
                    {% endfor -%}
                    {% endif -%}
                    {% if supply.ValueId == key -%}
                        {% assign childs = supply.Supplies -%}
                        {% if supply.Key == joinedKeys -%}
                            {% assign supplyId = supply.SupplyId -%}
                            {% assign attributeId = keys -%}
                        {% endif -%}
                    {% endif -%}
                    <option class="container-reload-js" {% if supply.ValueId == key -%} selected {% endif -%} data-url="{{ url }}?set-product-keys={{ dataKeys }}&set-product-id={{ setProductId }}" data-supply-id="{{ supply.SupplyId }}" value="{{ supply.ValueId }}">{{ supply.Value }}</option>
                {% endfor -%}
            </select>
            <div class="select__input">
                <span class="selected-js">
                    {% for supply in supplies -%}
                        {% if supply.ValueId == key -%}
                            {{ supply.Value }}
                        {% endif -%}
                    {% endfor -%}
                </span>
                <svg width="16" height="16">
                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}'></use>
                </svg>
            </div>
            <ul class="select__options options-js">
                {% for supply in supplies -%}
                    <li tabindex="-1" data-value="{{ supply.ValueId }}" class="container-reload-js" data-url="{{ url }}?set-product-keys={{ supply.Key }}&set-product-id={{ setProductId }}" data-supply-id="{{ supply.SupplyId }}">{{ supply.Value }}</li>
                {% endfor -%}
            </ul>
        </div>
        <div class="form__invalid-input validation-info-js validation-required-js hidden-js">
            {{ translations.FillAttributeValue }}
        </div>
        {% if supplyId -%}
            <input name="supplyId" type="hidden" value="{{ supplyId }}" class="set-product-supply-id-js" data-set-product-id="{{ setProductId }}">
            {% for keyVal in keys -%}
                <input name="attributeId" type="hidden" value="{{ keyVal }}" data-key="{{ keyVal }}">
            {% endfor -%}
        {% endif -%}
    </div>
{% endfor -%}
`